import { LinkBaseProps } from '@mui/material';
import { IconProps } from '@phosphor-icons/react';

import { RouterLink } from 'theSource/components/RouterLink';
import { Spacer } from 'theSource/components/Spacer';
import { IconWrapperStyled, LinkStyled } from './LinkStyled';
import { getDisplayValue, getPath } from './utils';

export type LinkType = 'tel' | 'email' | 'url';

type LinkVariant = 'link' | 'body1';

export interface LinkProps extends LinkBaseProps {
  value: string;
  path?: string;
  capitalize?: boolean;
  type?: LinkType;
  variant?: LinkVariant;
  internal?: boolean;
  testId?: string;
  underline?: boolean;
  disabled?: boolean;
  IconComponent?: React.ForwardRefExoticComponent<
    IconProps & React.RefAttributes<SVGSVGElement>
  >;
}

export const Link = ({
  value,
  path,
  capitalize = false,
  variant = 'link',
  type,
  internal = false,
  testId = 'link',
  underline = true,
  disabled = false,
  IconComponent,
  ...props
}: LinkProps) => (
  <LinkStyled
    data-testid={testId}
    variant={variant}
    href={getPath(value, type, path)}
    target={type === 'url' ? '_blank' : '_self'}
    component={disabled ? 'button' : internal ? RouterLink : 'a'}
    underline={underline ? 'always' : 'none'}
    $capitalize={capitalize}
    $underline={underline}
    disabled={disabled}
    {...props}
  >
    {IconComponent && (
      <>
        <IconWrapperStyled>
          <IconComponent data-testid="link-icon" size={16} weight="bold" />
        </IconWrapperStyled>
        <Spacer width={1} />
      </>
    )}
    {getDisplayValue(value, type)}
  </LinkStyled>
);
